import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";

type SimpleLayoutProps = {
  children?: React.ReactNode;
};

export function SimpleLayout({ children }: SimpleLayoutProps) {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/app" });

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate({ to: "/auth/login" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="container grid h-svh max-w-none items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex h-svh flex-col">
      <main className="flex-1 overflow-auto">{children ?? <Outlet />}</main>
    </div>
  );
}
